import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import ProfileRoles from '@/views/profile/Roles.vue';

export const profileRolesRoute: RouteConfig = {
  path: 'roles',
  name: 'profileRoles',
  component: ProfileRoles,
  meta: {
    title: 'titles.profile.roles'
  },
  beforeEnter(to: any, from: any, next: any) {
    store.commit('setting/group/setId', undefined);
    Promise.all([
      store.dispatch('role/list', { count: -1 }),
      store.dispatch('profile/roles/list'),
      store.dispatch('setting/list', { search: 'ADMIN_ROLE_ID' })
    ])
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'messages.role.listError' }));
  }
};
